import React from "react";
import ReactModal from "react-modal";

const TransformationDeleteModal: React.FC<{
  isOpen: boolean;
  onClose?: () => void;
  onConfirm?: () => void;
  header: string;
  body?: string;
  height?: number;
}> = ({ isOpen, onClose, onConfirm, header, body, height = 20 }) => {
  const customStyles = {
    content: {
      zIndex: 10050,
      minHeight: `${height}vh`,
      width: 600,
      top: "auto",
      bottom: "auto",
      right: "auto",
      left: "auto",
      position: "static" as "static",
      display: "flex",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, .8)",
      zIndex: 10000,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={customStyles}
      contentLabel="Confirm Deletion"
    >
      <div className="flex flex-col justify-between w-full">
        <div>
          <h2 className="text-xl text-gray-900">{header}</h2>
          {body && <p className="text-gray-600">{body}</p>}
        </div>
        <div className="flex space-between mt-10">
          <button
            className="w-full rounded btn py-2 text-center bg-purple-200 text-purple-900 hover:bg-purple-300"
            onClick={onClose}
          >
            Cancel
          </button>
          <div className="w-4 flex-shrink-0 flex-grow-0" />
          <button
            className="rounded w-full btn py-2 text-center bg-red-200 text-red-900 hover:bg-red-300"
            onClick={onConfirm}
          >
            Confirm
          </button>
        </div>
      </div>
    </ReactModal>
  );
};

export { TransformationDeleteModal };
